'use client';

import type { ProductReview } from '@eliadmin/core/src/api/products/types/product-types';
import { RatingStars } from '@eliadmin/core/src/components/dlz/ui/rating-stars';
import { REVIEW_COPY } from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-copy';
import { ReviewText } from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-text';
import {
  ratingOf,
  reviewAuthor,
} from '@eliadmin/core/src/components/dlz/product-detail/reviews/reviews';
import { useReviewFormat } from '@eliadmin/core/src/components/dlz/product-detail/reviews/use-product-reviews';

/** Figma „Review“ card of the teaser (60137:7979): author, date, stars and the first lines of the text. */
export function ReviewCard({ review }: { review: ProductReview }) {
  const format = useReviewFormat();
  const rating = ratingOf(review);

  return (
    <article className="flex h-full flex-col gap-3 rounded-[18px] border border-[#E2E4E7] bg-white p-4 md:p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <h3 className="dlz-body-s-medium dlz-trim min-w-0 flex-1 text-[#0F1012]">
            {reviewAuthor(review)}
          </h3>
          <time dateTime={review.created_at} className="dlz-caption dlz-trim text-[#6B7079]">
            {format.date(review.created_at)}
          </time>
        </div>
        <RatingStars value={rating} size="sm" label={REVIEW_COPY.summary.rating(String(rating))} />
      </header>
      <ReviewText text={review.review} className="dlz-body-s line-clamp-4 text-[#4F545C]" />
    </article>
  );
}
